import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { HOTJAR_SETTINGS, HotjarSettingsLoader, HotjarStaticSettingsLoader } from './providers/hotjar-settings.provider';
import { HotjarUserAttributesFakeLoader, HotjarUserAttributesLoader } from './providers/hotjar-user-attributes.provider';
import { HJ_PROVIDER } from './providers/hotjar.provider';

@NgModule({})
export class HotjarModule {
  /**
   * @param trackingCode Hotjar site id. Also acts as the fallback when a `settingsLoaderProvider`
   *   is supplied but fails to resolve.
   * @param settingsLoaderProvider Provider for a {@link HotjarSettingsLoader}, to resolve the
   *   tracking code at bootstrap instead of using `trackingCode` verbatim. Needed when one
   *   deployment serves several brands, each reporting to its own Hotjar site.
   */
  static forRoot(
    trackingCode: string,
    enabled: boolean,
    userAttributesProvider?: Provider,
    version = 6,
    settingsLoaderProvider?: Provider,
  ): ModuleWithProviders<HotjarModule> {
    return {
      ngModule: HotjarModule,
      providers: [
        {
          provide: HOTJAR_SETTINGS,
          useValue: {
            trackingCode,
            enabled,
            version,
          },
        },
        settingsLoaderProvider || { provide: HotjarSettingsLoader, useClass: HotjarStaticSettingsLoader },
        userAttributesProvider || { provide: HotjarUserAttributesLoader, useClass: HotjarUserAttributesFakeLoader },
        HJ_PROVIDER,
      ],
    };
  }
}
